import { useDispatch, useSelector } from "react-redux";
import { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CommonModal } from "./CommonModal";
import { Form, InputGroup, Col, Row } from "react-bootstrap";
import LinkSelect from "../general/LinkSelect";
import CancelIcon from "@material-ui/icons/Cancel";
import { Button, Typography } from "@material-ui/core";
import debounce from "lodash.debounce";
import Modal from "react-modal";
import * as theme from "../theme";
import {
  getClientLog,
  getProspectDoc,
  submitChangesForClient,
  submitConsentForClient,
  getPermanentCodeDetailsFromDoc,
  getCHS,
  getopenCHSconfirmationModal,
  openCHSconfirmationModalFun,
  getFormState,
  handleflashQid,
  handleBypassImportanceQ,
  getBypassImportanceQ,
  updateOtherDetails,
  updateProspectStatus
} from "../store/qf";
import download from "downloadjs";
import {
  clientHandOffModalClosed,
  getClientHandOffModalState,
  getQFuserMode,
  getGoToMarket,
  goToMarket,
  setautoreminder,
  sendChsEmail,
} from "../store/components";

import { getBrokerInformation } from "../store/broker";
import { getRowDetailsFromProspectId } from "../store/myquotes";
import translations from "../utils/translations";

export const ChsModalO = () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const [disableSbmtBtn, setdisableSbmtBtn] = useState(true);
  const [cbArr, setCbArr] = useState([false, false, false, null, null]);
  const [iconArr, setIconArr] = useState([false, false, false]);
  const [openModal, setopenModal] = useState(false);
  const [creditQDis, setcreditQDis] = useState("none");

  const clientHandOffModalOpen = useSelector(getClientHandOffModalState);
  const permanentcodedetails = useSelector(getPermanentCodeDetailsFromDoc);
  const showConfirmationModal = useSelector(getopenCHSconfirmationModal);
  const broker_info = useSelector(getBrokerInformation);
  const languagepreference = broker_info?.information?.languagepreference;
  const ChsModalOTranslation = translations[languagepreference]?.ChsModalO;

  const onSignatureChange = useMemo(
    () =>
      debounce((param, _event) => {
        updateCBArr(param, _event.target.value);
      }, 500),
    []
  );

  const updateCBArr = (index, state) => {
    const arr = [...cbArr];
    arr[index] = state;
    setCbArr((prevArr) => {
      const newArr = [...prevArr];
      newArr[index] = state;
      return newArr;
    });
  };

  const showThankyouPage = () => {
    try {
      if (broker_info?.brokerageImg.website) {
        window.location = "http://" + broker_info?.brokerageImg.website;
      } else history(`/thanksforanswers`);
    } catch (e) {
      return false;
    }
  };

  const updateIconArr = (index, bool = true) => {
    const arr = [...iconArr];
    arr[index] = bool;
    setIconArr(arr);
  };

  useEffect(() => {
    setopenModal(showConfirmationModal);
  }, [showConfirmationModal]);

  return (
    <CommonModal
      modalHeight={"60vh"}
      modalWidth={"55vw"}
      openModalBool={openModal}
      closeModal={() => dispatch(openCHSconfirmationModalFun(false))}
      handleSbmtBtn={() => {
        dispatch(openCHSconfirmationModalFun(false));
        dispatch(
          submitConsentForClient({
            date: new Date(),
            electronic_signature: cbArr[0],
            credit_score: cbArr[1],
            accuracy_info: cbArr[2],
            name: cbArr[3],
            role: cbArr[4],
          })
        );
        showThankyouPage();
      }}
      style={{ overflow: "hidden" }}
      buttontxt={ChsModalOTranslation.confirmAndSign}
      heading={ChsModalOTranslation.applicationSignatureAndConsent}
      innerOverflow={"auto"}
      isDisabledSbmtBtn={disableSbmtBtn}
    >
      <p style={{ width: "90%", display: "none", fontSize: 15 }}>
        {ChsModalOTranslation.electronicApplicationNotice}
      </p>
      <div style={{ display: "flex", width: "100%" }}>
        <Form.Check
          inline
          label={
            ChsModalOTranslation.consentToElectronicDisclosuresAndSignature
          }
          name="group1"
          type="checkbox"
          style={{
            marginTop: "6px",
            gridArea: "2 / 1 / 3 / 3",
            fontFamily: "GibsonRegular",
          }}
          id={`inline-checkbox-1`}
          onClick={(e) => {
            console.log(e.target.checked);
            updateCBArr(0, e.target.checked);
          }}
        />
        <Button
          onClick={() => updateIconArr(0)}
          style={{
            backgroundColor: "grey",
            color: "white",
            fontSize: 9,
            display: !iconArr[0] ? "block" : "none",
          }}
        >
          {ChsModalOTranslation.viewFullDisclosureStatement}
        </Button>
      </div>
      <div>
        <p
          style={{
            display: iconArr[0] ? "block" : "none",
            fontSize: 15,
            marginTop: "5px",
          }}
        >
          {ChsModalOTranslation.eSignatureAgreementText}
        </p>
      </div>
      <div style={{ display: creditQDis, width: "100%", marginTop: "6px" }}>
        <Form.Check
          inline
          label={ChsModalOTranslation.consentToUseCreditScore}
          name="group1"
          type="checkbox"
          style={{
            marginTop: "6px",
            gridArea: "2 / 1 / 3 / 3",
            fontFamily: "GibsonRegular",
          }}
          id={`inline-checkbox-2`}
          onClick={(e) => {
            updateCBArr(1, e.target.checked);
          }}
        />
        <Button
          onClick={() => updateIconArr(1)}
          style={{
            backgroundColor: "grey",
            color: "white",
            fontSize: 9,
            display: !iconArr[1] ? "block" : "none",
          }}
        >
          {ChsModalOTranslation.viewFullDisclosureStatement}
        </Button>
      </div>
      <div>
        <p
          style={{
            display: iconArr[1] ? "block" : "none",
            fontSize: 15,
            marginTop: "5px",
          }}
        >
          {ChsModalOTranslation.creditInfoConsentDetails}
        </p>
      </div>
      <div style={{ display: "flex", width: "100%", marginTop: "6px" }}>
        <Form.Check
          inline
          label={ChsModalOTranslation.confirmAccuracyOfInformation}
          name="group1"
          type="checkbox"
          style={{
            marginTop: "6px",
            gridArea: "2 / 1 / 3 / 3",
            fontFamily: "GibsonRegular",
          }}
          id={`inline-checkbox-3`}
          onClick={(e) => {
            updateCBArr(2, e.target.checked);
          }}
        />
        <Button
          onClick={() => updateIconArr(2)}
          style={{
            backgroundColor: "grey",
            color: "white",
            fontSize: 9,
            display: !iconArr[2] ? "block" : "none",
          }}
        >
          {ChsModalOTranslation.viewFullDisclosureStatement}
        </Button>
      </div>
      <div>
        <p
          style={{
            display: iconArr[2] ? "block" : "none",
            fontSize: 15,
            marginTop: "5px",
          }}
        >
          {ChsModalOTranslation.creditInfoConsentDetails}
        </p>
      </div>
      <div style={{ height: "5vh" }} />
      <Form.Group as={Row}>
        <Form.Label column sm="4">
          {ChsModalOTranslation.nameOfAuthorizedIndividual}
        </Form.Label>
        <Col sm="6">
          <Form.Control
            type="text"
            onChange={(e) => onSignatureChange(3, e)}
            style={{ fontFamily: "Cedarville Cursive" }}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label column sm="4">
          {ChsModalOTranslation.roleWithinBusiness}
        </Form.Label>
        <Col sm="6">
          <Form.Control type="text" onChange={(e) => onSignatureChange(4, e)} />
        </Col>
      </Form.Group>
    </CommonModal>
  );
};

export const GtmModal = (props) => {
  // go to Market modal
  // only show this modal when user clicks go to market && do not show again is false && there are important questions
  // show modal of all important questions that are not answered
  const getUnansweredImportantQuestions = () => {
    // Extract all missing important questions
    let allMissingImportantQuestions = [];
    for (const group in gotProspectFormState) {
      const nodestate = gotProspectFormState[group]?.nodestate;
      if (nodestate) {
        const missingAnswers = Object.values(nodestate).filter(
          (x) =>
            x.importance > 3 &&
            ([null, ""].includes(x.answer) ||
              !("answer" in x) ||
              (Array.isArray(x.answer) && x.answer.length === 0)) &&
            x.type !== "message"
        );
        if (missingAnswers.length) {
          allMissingImportantQuestions.push(...missingAnswers);
        }
      }
    }
    // If no missing questions, return early
    if (!allMissingImportantQuestions.length) return [];
    return allMissingImportantQuestions;
  };

  const waitForElement = (selector, callback) => {
    const observer = new MutationObserver((mutationsList, observer) => {
      const element = document.getElementById(selector);
      if (element) {
        observer.disconnect(); // Stop observing once the element is found
        callback(element);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const navigatetoQuestion = (firstQuestion) => {
    const questionId = `QuestionID_${firstQuestion.id}`;
    const formtypeId = `formtype_${firstQuestion.formtype}_${firstQuestion.formid}`;
    const groupId = `groupid_${firstQuestion.groupid}`;

    const formtypeNav = document.getElementById(formtypeId);
    let grouptypeNav = document.getElementById(groupId);
    if (firstQuestion.formtype === "location") {
      const buildingId = `location_${firstQuestion.locationid}_building_${firstQuestion.buildingid}_59000a`;
      const locationId = `location_${firstQuestion.locationid}`;
      const locationGroupHeaderId = `location_${firstQuestion.locationid}_${firstQuestion.groupid}`;

      let buildingNav = document.getElementById(buildingId);
      let locationNav = document.getElementById(locationId);
      let locationGroupHeaderNav = document.getElementById(
        locationGroupHeaderId
      );

      if (!["", null, undefined].includes(firstQuestion.buildingid)) {
        if (!buildingNav && formtypeNav) {
          formtypeNav.click();
          waitForElement(buildingId, (nav) => nav.click());
        } else {
          buildingNav?.click();
        }
      } else {
        if (locationGroupHeaderNav) {
          locationGroupHeaderNav.click();
        } else if (!locationNav && formtypeNav) {
          formtypeNav.click();
          waitForElement(locationId, (nav) => {
            nav.click();
            waitForElement(locationGroupHeaderId, (headerNav) =>
              headerNav.click()
            );
          });
        } else {
          locationNav?.click();
          waitForElement(locationGroupHeaderId, (headerNav) =>
            headerNav.click()
          );
        }
      }
    } else {
      if (!grouptypeNav && formtypeNav) {
        formtypeNav.click();
        waitForElement(groupId, (nav) => nav.click());
      } else {
        grouptypeNav?.click();
      }
    }

    waitForElement(questionId, (questionElement) => {
      questionElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      dispatch(handleflashQid(firstQuestion.id));
    });
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { prospectId } = props;
  const GoToMarketClicked = useSelector(getGoToMarket);
  const gotProspectFormState = useSelector(getFormState);
  const bypassImportanceQ = useSelector(getBypassImportanceQ);
  let MissingImpQuestions = getUnansweredImportantQuestions();
  const broker_info = useSelector(getBrokerInformation);
  const languagepreference = broker_info?.information?.languagepreference;
  const GtmModalTranslation = translations[languagepreference]?.GtmModal;

  useEffect(() => {
    if (bypassImportanceQ && GoToMarketClicked) {
      dispatch(goToMarket(false));
      console.log("Closed modal");
      navigate(`/quotes?id=${prospectId}`);
    }
  }, [GoToMarketClicked]);

  useEffect(() => {
    // if gotoMarket is clicked and all important questions answered, auto redirect
    if (GoToMarketClicked && MissingImpQuestions.length === 0) {
      navigate(`/quotes?id=${prospectId}`);
    }
  }, [GoToMarketClicked, MissingImpQuestions]);

  let modalHeight = MissingImpQuestions.length > 7 ? "80vh" : "70vh";
  return (
    <>
      <CommonModal
        modalHeight={modalHeight}
        modalWidth={"55vw"}
        openModalBool={GoToMarketClicked}
        closeModal={() => {
          console.log("close button pressed");
          dispatch(goToMarket(false));
        }}
        handleSbmtBtn={() => {
          console.log("Submit button pressed");
          dispatch(updateProspectStatus({prospectid:prospectId, statuscode:'app_completed' }))
          setTimeout(() => {
            navigate(`/quotes?id=${prospectId}`);
          }, 500);
        }}
        style={{ overflow: "hidden" }}
        buttontxt={GtmModalTranslation.gtmGoToMarket}
        heading={GtmModalTranslation.gtmUnansweredQuestionsList}
        innerOverflow={"auto"}
        innerOverflowY={"hidden"}
        isDisabledSbmtBtn={false}
        backgroundColorBody={"rgb(217, 221, 234)"}
        textColor={"black"}
        buttonTextColor={"white"}
        backgroundColorSbmtBtn={"rgb(102, 102, 102)"}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "space-between",
          }}
        >
          <h5 style={{ marginBottom: "1em" }}>
            {GtmModalTranslation.gtmUnansweredQuestionsDescription}
          </h5>

          <ul style={{ maxHeight: "70%", overflowY: "auto", fontSize: "16px" }}>
            {MissingImpQuestions.map((x) => {
              let parentKey = "";
              if (
                gotProspectFormState[x.formid]?.groupstate &&
                gotProspectFormState[x.formid]?.groupstate[x.groupid]?.text[
                  languagepreference
                ]
              ) {
                parentKey =
                  gotProspectFormState[x.formid].groupstate[x.groupid].text[
                    languagepreference
                  ];
              } else if (
                gotProspectFormState[x.formid].locationstate &&
                gotProspectFormState[x.formid].locationstate[x.locationid]
                  ?.buildings?.[x.buildingid]?.groupstate[x.groupid]
              ) {
                parentKey = `${languagepreference === "fr" ? "Emplacement" : "Location"} ${x.locationid} > ${languagepreference === "fr" ? "Bâtiment" : "Building"} ${
                  x.buildingid + 1
                } > ${
                  gotProspectFormState[x.formid].locationstate[x.locationid]
                    ?.buildings?.[x.buildingid].groupstate[x.groupid].text[languagepreference]
                }`;
              } else if (
                gotProspectFormState[x.formid].locationstate &&
                gotProspectFormState[x.formid].locationstate[x.locationid]
                  ?.groupstate[x.groupid]
              ) {
                parentKey = `${languagepreference === "fr" ? "Emplacement" : "Location"} ${x.locationid} > ${
                  gotProspectFormState[x.formid].locationstate[x.locationid]
                    ?.groupstate[x.groupid].text[languagepreference]
                }`;
              } else {
                console.log("Missing info");
                console.log(x);
                console.log(gotProspectFormState[x.formid]);
              }
              return (
                <div key={x.id}>
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      dispatch(goToMarket(false));
                      navigatetoQuestion(x);
                    }}
                  >
                    {`${parentKey} > ${x.text[languagepreference]}`}
                  </p>
                </div>
              );
            })}
          </ul>

          <div className="d-flex align-items-center justify-content-center">
            <Form.Check
              label={
                <span style={{ fontSize: "20px", verticalAlign: "top" }}>
                  {GtmModalTranslation.gtmDoNotShowAgain}
                </span>
              }
              style={{ margin: 0, marginBottom: "3%" }}
              name="group1"
              type="checkbox"
              id={`bigger-checkbox`}
              onClick={(e) => {
                console.log(e.target.checked);
                dispatch(handleBypassImportanceQ(e.target.checked));
                dispatch(
                  updateOtherDetails({
                    prospectid: prospectId,
                    bypassImportanceQ: e.target.checked,
                  })
                );
              }}
            />
          </div>
        </div>
      </CommonModal>
    </>
  );
};

export const ChsSignoffModal = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    prospectId,
    openModal,
    openCHSconfirmationModalFun,
    cbArr,
    updateCBArr,
    showThankyouPage,
    submitConsentForClient,
    disableSbmtBtn,
    creditQDis,
    updateIconArr,
    iconArr,
    onSignatureChange,
  } = props;
  const broker_info = useSelector(getBrokerInformation);
  const languagepreference = broker_info?.information?.languagepreference;
  const ChsSignoffModalTranslation =
    translations[languagepreference]?.ChsSignoffModal;

  return (
    <CommonModal
      modalHeight={"60vh"}
      modalWidth={"55vw"}
      openModalBool={openModal}
      closeModal={() => dispatch(openCHSconfirmationModalFun(false))}
      handleSbmtBtn={() => {
        dispatch(openCHSconfirmationModalFun(false));
        dispatch(
          submitConsentForClient({
            date: new Date(),
            electronic_signature: cbArr[0],
            credit_score: cbArr[1],
            accuracy_info: cbArr[2],
            name: cbArr[3],
            role: cbArr[4],
          })
        );
        showThankyouPage();
      }}
      style={{ overflow: "hidden" }}
      buttontxt={ChsSignoffModalTranslation.chsButtontxt}
      heading={ChsSignoffModalTranslation.chsHeading}
      innerOverflow={"auto"}
      isDisabledSbmtBtn={disableSbmtBtn}
      hideSbmtBtn={true}
      bodyFlexDirection={"unset"}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column", // Stacks content vertically
          height: "100%", // Ensures the parent div spans the full modal height
          justifyContent: "space-evenly",
        }}
      >
        <div>
          <p style={{ width: "90%", display: "none", fontSize: 15 }}>
            {ChsSignoffModalTranslation.chsElectronicApplicationNotice}
          </p>
        </div>
        <div>
          <div style={{ display: "flex", width: "100%" }}>
            <Form.Check
              inline
              label={ChsSignoffModalTranslation.chsConsentElectronicDisclosures}
              name="group1"
              type="checkbox"
              style={{
                marginTop: "6px",
                gridArea: "2 / 1 / 3 / 3",
                fontFamily: "GibsonRegular",
              }}
              id={`inline-checkbox-1`}
              onClick={(e) => {
                console.log(e.target.checked);
                updateCBArr(0, e.target.checked);
              }}
            />
            {/* <InfoIcon
              fontSize="small"
              style={{
                display : !iconArr[0] ? "block" : "none" ,
                marginRight: "3%",
                marginTop: "7px",
              }}
              onClick={(e) => updateIconArr(0) }
            ></InfoIcon> */}
            <Button
              onClick={() => updateIconArr(0)}
              style={{
                backgroundColor: "grey",
                color: "white",
                fontSize: 9,
                display: !iconArr[0] ? "block" : "none",
              }}
            >
              {ChsSignoffModalTranslation.chsViewFullDisclosure}
            </Button>
          </div>
          <p
            style={{
              display: iconArr[0] ? "block" : "none",
              fontSize: 15,
              marginTop: "5px",
            }}
          >
            {ChsSignoffModalTranslation.chsESignatureAgreementText}
          </p>
        </div>
        <div>
          <div style={{ display: creditQDis, width: "100%", marginTop: "6px" }}>
            <Form.Check
              inline
              label={ChsSignoffModalTranslation.chsConsentCreditScore}
              name="group1"
              type="checkbox"
              style={{
                marginTop: "6px",
                gridArea: "2 / 1 / 3 / 3",
                fontFamily: "GibsonRegular",
              }}
              id={`inline-checkbox-2`}
              onClick={(e) => {
                updateCBArr(1, e.target.checked);
              }}
            />
            {/* <InfoIcon
              fontSize="small"
              style={{
                display : !iconArr[1] ? "block" : "none" ,
                marginRight: "3%",
                marginTop: "7px",
              }}
              onClick={() => updateIconArr(1) }
            ></InfoIcon> */}
            <Button
              onClick={() => updateIconArr(1)}
              style={{
                backgroundColor: "grey",
                color: "white",
                fontSize: 9,
                display: !iconArr[1] ? "block" : "none",
              }}
            >
              {ChsSignoffModalTranslation.chsViewFullDisclosure}
            </Button>
          </div>
          <p
            style={{
              display: iconArr[1] ? "block" : "none",
              fontSize: 15,
              marginTop: "5px",
            }}
          >
            {ChsSignoffModalTranslation.chsCreditInfoConsentDetails}
          </p>
        </div>
        <div>
          <div style={{ display: "flex", width: "100%", marginTop: "6px" }}>
            <Form.Check
              inline
              label={ChsSignoffModalTranslation.chsConfirmAccuracy}
              name="group1"
              type="checkbox"
              style={{
                marginTop: "6px",
                gridArea: "2 / 1 / 3 / 3",
                fontFamily: "GibsonRegular",
              }}
              id={`inline-checkbox-3`}
              onClick={(e) => {
                updateCBArr(2, e.target.checked);
              }}
            />
            {/* <InfoIcon
              fontSize="small"
              style={{
                display : !iconArr[2] ? "block" : "none" ,
                marginRight: "3%",
                marginTop: "7px",
              }}
              onClick={() => updateIconArr(2) }
            ></InfoIcon> */}
            <Button
              onClick={() => updateIconArr(2)}
              style={{
                backgroundColor: "grey",
                color: "white",
                fontSize: 9,
                display: !iconArr[2] ? "block" : "none",
              }}
            >
              {ChsSignoffModalTranslation.chsViewFullDisclosure}
            </Button>
          </div>
          <p
            style={{
              display: iconArr[2] ? "block" : "none",
              fontSize: 15,
              marginTop: "5px",
            }}
          >
            {ChsSignoffModalTranslation.chsInsurerRelianceText}
          </p>
        </div>
        <div style={{ height: "5vh" }} />
        <div
          style={{
            display: "flex",
            alignItems: "stretch",
            justifyContent: "space-between",
            gap: "5px",
            fontSize: "15px",
            width: "95%",
            paddingBottom: "1.5%",
          }}
        >
          <div style={{ flex: 1 }}>
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm="4">
                {ChsSignoffModalTranslation.chsAuthorizedIndividual}
              </Form.Label>
              <Col sm="7">
                <Form.Control
                  type="text"
                  onChange={(e) => onSignatureChange(3, e)}
                  style={{ fontFamily: "Cedarville Cursive" }}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm="4">
                {ChsSignoffModalTranslation.chsRoleWithinBusiness}
              </Form.Label>
              <Col sm="7">
                <Form.Control
                  type="text"
                  onChange={(e) => onSignatureChange(4, e)}
                />
              </Col>
            </Form.Group>
          </div>

          <Button
            variant="warning"
            onClick={() => {

              dispatch(openCHSconfirmationModalFun(false));
              dispatch(
                submitConsentForClient({
                  date: new Date(),
                  electronic_signature: cbArr[0],
                  credit_score: cbArr[1],
                  accuracy_info: cbArr[2],
                  name: cbArr[3],
                  role: cbArr[4],
                })
              );
              showThankyouPage();
            }}
            disabled={disableSbmtBtn}
            style={{
              backgroundColor: disableSbmtBtn ? "gray" : "#FFD700", // Yellow color
              color: "#000", // Black text
              fontWeight: "bold",
              cursor: disableSbmtBtn ? "not-allowed" : "pointer", // Show a "not-allowed" cursor when disabled
              opacity: disableSbmtBtn ? 0.5 : 1,
            }}
          >
            {ChsSignoffModalTranslation.chsButtontxt}
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export const ChsModal = ({ prospectid }) => {
  const clientHandOffModalOpen = useSelector(getClientHandOffModalState);
  const formstate = useSelector(getFormState);
  const dispatch = useDispatch();
  const chs_ = useSelector(getCHS);
  var [showList, setshowList] = useState([]);
  const [isExpressApp, setExpressApp] = useState(false);
  const [chs, setchs] = useState(chs_);
  const [isEmail, setEmail] = useState(false);
  const userInformation = useSelector(getBrokerInformation);
  useEffect(() => {
    var sortedList = showList.sort((a, b) => a.sort - b.sort);
    var urlStringJoin = sortedList.map((x) => x.name).join(",");
    setchs(
      chs_ +
        "&show=" +
        encodeURIComponent(urlStringJoin) +
        "&isExpressApp=" +
        isExpressApp+
        "&languagepreference="+languagepreference
   );
  }, [showList, isExpressApp]);
  if(!userInformation || !userInformation?.information || !formstate || !formstate.a  ){
    // early return so rest of component doesnt render and cause WSD
    return; 
  }
  const languagepreference = userInformation?.information?.languagepreference;
  const chsModalTranslation = translations[languagepreference]?.chsModal;
  let brokerEmail = userInformation?.information?.user?.email ||' ';
  let clientEmail = formstate?.a?.nodestate?.[10103]?.answer;
  let clientName = (formstate?.a?.nodestate?.[10101]?.answer || "")
    .trim()
    .split(" ")[0];
  let brokerName = userInformation?.information?.user?.name||" ";
  var groupList = Object.values(formstate)
    .filter((t) => !t?.questionid)
    .map((x) => {
      return { name: x?.text?.[languagepreference], id: x?.id };
    });
  



  const handleCheck = (e) => {
    var name = e.target.getAttribute("info");
    var sort = e.target.getAttribute("sort");
    if (e.target.checked) {
      setshowList([...showList, { name, sort }]);
    } else {
      var deleted = showList.filter((x) => x.name != name);
      setshowList([...deleted]);
    }
  };

  const handleExpressAppCheck = (e) => {
    setExpressApp(e.target.checked);
  };

  const styles = {
    row: {
      display: "flex",
      alignItems: "center",
      marginBottom: 10,
      justifyContent: "space-between",
      width: "90%",
    },
    label: {
      width: "50%",
      fontWeight: 500,
    },
    buttonGroup: {
      display: "flex",
      gap: "5px",
      width: "100%",
    },
    checkbox: {
      width: "20px",
      height: "20px",
    },
  };

  return (
    <Modal
      isOpen={clientHandOffModalOpen}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          maxHeight: `81vh`,
          minHeight: `60vh`,
          height: "auto",
          width: `28vw`,
          position: "absolute",
          top: `${Math.floor((100 - 95) / 2)}vh`,
          left: `${Math.floor((100 - 25) / 2)}vw`,
          right: 0,
          bottom: 0,
          WebkitOverflowScrolling: "touch",
          border: "8px solid white",
          borderRadius: "20px",
          padding: 0,
          overflow: "auto",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "98%",
          flexGrow: 1,
        }}
      >
        <div
          style={{
            width: "100%",
            height: "10%",
            color: "black",
            fontSize: "2.8vmin",
            padding: "2vh",
            fontFamily: "GibsonSemiBd",
            letterSpacing: 1,
            backgroundColor: "lightgrey",
          }}
        >
          {chsModalTranslation.handoffHeader}
          <div style={{ position: "absolute", top: 10, right: 10 }}>
            <CancelIcon
              fontSize="large"
              style={{ cursor: "pointer", color: "white" }}
              onClick={() => {
                dispatch(clientHandOffModalClosed());
                setTimeout(() => {
                  dispatch(
                    setautoreminder({
                      text: chsModalTranslation.reminderText,
                      title: chsModalTranslation.reminderTitle,
                      prospectid,
                      remindercategory: chsModalTranslation.reminderCategory,
                    })
                  );
                }, 500);
              }}
            ></CancelIcon>
          </div>
        </div>
        <div
          style={{
            color: "black",
            marginLeft: "1vw",
            marginTop: "1.5vh",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <p>{chsModalTranslation.instructionText}</p>
          <div>
            <p>{chsModalTranslation.sectionsIncludeQuestion}</p>
            <div
              style={{
                marginLeft: "2vw",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "35%",
                alignItems: "baseline",
                paddingBottom: "1em",
              }}
            >
              <label htmlFor={`checkbox_all`} style={{ marginLeft: "1vw" }}>
                {chsModalTranslation.includeAll}
              </label>
              <input
                type="checkbox"
                id={`checkbox_all`}
                onClick={() => {
                  setshowList([]);
                }}
                style={styles.checkbox}
                checked={showList.length == 0}
              ></input>
            </div>
          </div>
          <p>{chsModalTranslation.includeSpecific}</p>
          {groupList.map((x, idx) => (
            <div
              key={`${idx}_checkrow`}
              style={{
                marginLeft: "2vw",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "50%",
                alignItems: "baseline",
              }}
            >
              <label htmlFor={`checkbox_${x.id}`} style={{ marginLeft: "1vw" }}>
                {x.name}
              </label>
              <input
                style={styles.checkbox}
                type="checkbox"
                id={`checkbox_${x.id}`}
                sort={idx}
                info={x.id}
                onClick={handleCheck}
                checked={showList.find((t) => t.name == x.id)}
              ></input>
            </div>
          ))}
          <div style={{ ...styles.row, paddingTop: "10px" }}>
            <Typography style={{ ...styles.label, width: "65%" }}>
              {chsModalTranslation.shortenedApplicationQuestion}
            </Typography>
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                onClick={() => {
                  setExpressApp(true);
                }}
                style={{
                  color: "white",
                  backgroundColor: isExpressApp
                    ? theme.COLORS.secondary_skyblue
                    : "black",
                }}
              >
                {chsModalTranslation.turbo}
              </Button>
              <Button
                onClick={() => {
                  setExpressApp(false);
                }}
                style={{
                  color: "white",
                  backgroundColor: !isExpressApp
                    ? theme.COLORS.secondary_skyblue
                    : "black",
                }}
              >
                {chsModalTranslation.full}
              </Button>
            </div>
          </div>
          <div style={styles.row}>
            <Typography style={{ ...styles.label, width: "65%" }}>
              {chsModalTranslation.emailOrLinkQuestion}
            </Typography>
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                onClick={() => {
                  setEmail(true);
                }}
                style={{
                  color: "white",
                  backgroundColor: isEmail
                    ? theme.COLORS.secondary_skyblue
                    : "black",
                }}
              >
                {chsModalTranslation.email}
              </Button>
              <Button
                onClick={() => {
                  setEmail(false);
                }}
                style={{
                  color: "white",
                  backgroundColor: !isEmail
                    ? theme.COLORS.secondary_skyblue
                    : "black",
                }}
              >
                {chsModalTranslation.link}
              </Button>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            color: "black",
            fontSize: "1.8vmin",
            padding: "2vh",
            fontFamily: "GibsonSemiBd",
            letterSpacing: 1,
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: isEmail ? "none" : "flex",
              width: "100%",
              height: "50%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "100%" }}>
              <LinkSelect text={chs} iconcolor={"black"} chs={true} />
            </div>
          </div>
          <div
            style={{
              display: isEmail && false ? "flex" : "none",
            }}
          >
            {`Sending email to ${brokerEmail} , ${clientEmail} ...`}
          </div>
        </div>
        <Button
          style={{
            backgroundColor: theme.COLORS.secondary_skyblue,
            color: "white",
          }}
          onClick={() => {
            dispatch(clientHandOffModalClosed());
            dispatch(updateProspectStatus({prospectid, statuscode:'app_with_client'}))
            if (isEmail) {
              let subject = chsModalTranslation.emailSubject;
              let body = chsModalTranslation.emailBody
                .replace("{clientName}", clientName)
                .replace("{link}", chs)
                .replace("{brokerName}", brokerName);
              let emlContent = "To: " + clientEmail + "\n";
              emlContent += `Subject: ${subject}\n`;
              emlContent += "X-Unsent: 1\n";
              emlContent += "Mime-Version: 1.0\n";
              emlContent += `Content-Type: text/html; charset="utf-8"\n`;
              emlContent += "Content-Transfer-Encoding: 8bit\n\n";
              emlContent += body;

              const blob = new Blob([emlContent], { type: "message/rfc822;charset=utf-8" });
              download(blob, "OpenWithOutlook.eml", "message/rfc822");
            }
            setTimeout(() => {
              dispatch(
                setautoreminder({
                  text: chsModalTranslation.reminderText,
                  title: chsModalTranslation.reminderTitle,
                  prospectid,
                  remindercategory: chsModalTranslation.reminderCategory,
                })
              );
            }, 500);
          }}
        >
          {chsModalTranslation.finish}
        </Button>
      </div>
    </Modal>
  );
};
